const isRelativeUrl = (url) => {
  // A simple heuristic: check if the URL doesn't start with http/https/mailto/etc.
  return !/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url);
};

function transformLinkUri(uri) {
  if (isRelativeUrl(uri)) {
    return `http://${uri}`;
  }
  return uri;
}

export default transformLinkUri;
